"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/styles");
const ico_close_png_1 = __importDefault(require("../../../../assets/img/ico-close.png"));
const success_icon_png_1 = __importDefault(require("../../../../assets/img/success_icon.png"));
exports.default = (0, styles_1.makeStyles)(() => ({
    dialog: {
        borderRadius: '5px',
        borderWidth: '0px',
        outline: 0,
        width: '320px',
        height: '170px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: '"Open Sans", Helvetica,Arial,sans-serif',
        background: '#f7f7f7',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1102
    },
    DialogContent: {
        width: '320px',
        overflow: 'hidden',
        position: 'relative',
        padding: '6px 10px 8px',
        marginTop: '-12px'
    },
    WrapIcon: {
        position: 'relative',
        background: `url(${success_icon_png_1.default}) no-repeat`,
        width: 33,
        height: 33,
        display: 'block',
        backgroundSize: 'contain',
        margin: '32px 134px'
    },
    ListItem: {
        marginTop: '-45px',
        paddingLeft: '74px'
    },
    typography: {
        'margin-left': '-20px',
        'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#2f3c54',
        fontWeight: 600,
        fontFamily: '"Open Sans", Helvetica,Arial,sans-serif',
        fontSize: '18px',
        lineHeight: 1.4
    },
    tips2: {
        marginLeft: '21px'
    },
    tips3: {
        marginLeft: '5px'
    },
    IconClose: {
        position: 'absolute',
        textDecoration: 'none',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        display: 'block',
        top: '24px',
        right: '24px',
        cursor: 'pointer',
        zIndex: 1103
    }
}));
